<template>
  <v-tooltip
    class='w-tooltip'
    :content-class='`w-tooltip__content-wrapper ${contentClass}`'
    :value='value || internalShow'
    v-bind='$props'
    @input='handleInput'
  >
    <template #activator="{ on, attrs }">
      <slot
        name='tooltip-activator'
        :on='on'
        :attrs='attrs'
      />
    </template>
    <span class='w-tooltip__content'>
      <slot name='tooltip' />
    </span>
  </v-tooltip>
</template>

<script>
import { VTooltip } from 'vuetify/lib';
const HALF_SECOND = 500;

export default {
  name: 'WorkTooltip',
  props: {
    ...VTooltip.options.props,
    value: { type: Boolean, default: undefined },
    bottom: { type: Boolean, default: true },
    transition: { type: String, default: "slide-y-transition" },
    color: { type: String, default: 'primary' },
    openDelay: { type: [Number,String], default: HALF_SECOND },
  },
  data() {
    return {
      internalShow: false
    };
  },
  methods: {
    handleInput(show) {
      this.internalShow = show;
      this.$emit('input', show);
    }
  }
};
</script>

<style lang='scss'>
.w-tooltip__content-wrapper {
  border-radius: 1rem;
  padding: 0.25rem 0.5rem;
  pointer-events: initial;

  .w-tooltip__content {
    font-size: $w-p4-font-size;
    font-weight: $w-p4-font-weight;
  }
}
</style>
